import React from 'react';
import Badge from 'react-bootstrap/Badge';
import Icon, { Icons } from '../icon/Icon';

// Define the shape of a single label
export interface TicketStatusLabel {
  id: string;
  name: string;
  color: string;
  icon: keyof typeof Icons;
}

type TicketStatusLabelsProps = {
  ticketStatusLabels: TicketStatusLabel[];
};

/**
 * Renders a list of ticket status labels as styled badges.
 * Uses react-bootstrap <Badge /> and a custom <Icon /> component.
 */
const TicketStatusLabels: React.FC<TicketStatusLabelsProps> = ({ ticketStatusLabels }) => {
  if (!ticketStatusLabels || ticketStatusLabels.length === 0) {
    return null;
  }

  return (
    <div className="bm-TicketStatusLabels d-flex flex-wrap">
      {ticketStatusLabels.map(label => (
        <Badge
          key={label.id}
          bg={label.color}
          style={{
            backgroundColor: label.color,
            color: '#000',
            opacity: 0.9,
            paddingTop: '0.4rem',
            paddingBottom: '0.4rem',
          }}
          className="mr-2 mb-1 d-flex align-items-center"
        >
          <Icon name={Icons[label.icon]} solid size={18} className="bm-Icon--dark mr-1" />
          <h5 className="m-0 p-0" style={{ fontSize: '0.8rem' }}>{label.name}</h5>
        </Badge>
      ))}
    </div>
  );
};

export default TicketStatusLabels;
